import { render, staticRenderFns } from "./CustomerWeeklyPallets.vue?vue&type=template&id=4b9065c6&scoped=true&"
import script from "./CustomerWeeklyPallets.vue?vue&type=script&lang=ts&"
export * from "./CustomerWeeklyPallets.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerWeeklyPallets.vue?vue&type=style&index=0&id=4b9065c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9065c6",
  null
  
)

export default component.exports